export class AlertaMasiva {
    constructor(
        public dispositivo: string,
        public canal: string,
        public alto: number,
        public bajo: number
    ){}
}